export const SHUTTERSTOCK_DIGITAL_GOODS_ID = {
  PICTURE: `32366262-3737-3438-2D38-3537332D3333`,
  VIDEO: `32313337-3765-3164-2D66-6164332D3131`
};